





import { Vue, Component } from 'vue-property-decorator'
import { store } from '../../../../../store'

@Component
export default class extends Vue {
  get mapName() {
    const gc = store.galaxyCruise
    if (gc.series === 'season_1') {
      return gc.quest.level.id - 1
    } else {
      return 'blank'
    }
  }
}
